// eslint-disable-next-line import/prefer-default-export
export function loadScript({
  src, async = true, defer = true, crossorigin,
}) {
  return new Promise((resolve, reject) => {
    // 已经存在同样 src 的 script，不重复加载
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve()
      return
    }

    const script = document.createElement('script')
    script.src = src
    script.async = async
    script.defer = defer
    if (crossorigin) script.crossOrigin = crossorigin

    script.onload = () => resolve()
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`))

    document.head.appendChild(script)
  })
}
